import { Alert } from '@mui/material';
import { ScopeEnum } from 'src/domain';
import { useScope } from 'src/hooks';
import { useIsMixedCurrency } from 'src/hooks/useIsMixedCurreny';

export const MixedCurrencyAlert = () => {
    const isMixedCurrency = useIsMixedCurrency();
    const scope = useScope();

    if (scope !== ScopeEnum.PARTNER) return null;
    if (!isMixedCurrency) return null;

    return (
        <Alert severity="warning">
            The data shown at for this partner may be inaccurate because not all stores use the same currency.
        </Alert>
    );
};
